import he from 'he';

/**
 * Decodes HTML entities in a given string.
 * @param {string} input - The text with HTML entities.
 * @returns {string} - Decoded text.
 */
export function decodeHtml(input) {
  if (!input) return ''; // Return an empty string if input is null or undefined
  return he.decode(input);
}
